import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[fixedSizeElement]',
    standalone: false
})
export class FixedSizeElementDirective {
  readonly element: ElementRef = inject(ElementRef);
}
